<template>
  <div class="ruleShow seller-style">
    <h2 class="f18 fb normal gray_2">规则展示</h2>
    <div class="box20"></div>
    <Tinymce ref="tinymce" id="id" :contentInit="contentInit"></Tinymce>
    <div class="box20"></div>
    <div class="text-center">
      <el-button type="primary" class="mar30-r" @click="saveRule">确 定</el-button>
      <el-button @click="cancelRule">取 消</el-button>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/tinymce";

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      ruleId: "",
      shopId: "",
      contentInit: {},
    };
  },
  created() {
    this.ruleId = this.$route.query.ruleId;
    this.shopId = this.$route.query.shopId;
    this.getPointsRule();
  },
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    getPointsRule() {
      if (!this.ruleId) {
        return;
      }
      let params = this.$qs.stringify({ shopId: this.shopId });
      this.$store.dispatch("points/points/getPointsRule", params).then((data) => {
        if (!data) {
          return;
        }
        this.$refs.tinymce.setMain(data.rule);
      });
    },
    saveRule() {
      const rule = {
        id: this.ruleId,
        shopId: this.shopId,
        rule: this.$refs.tinymce.getMain(),
      };
      this.$store.dispatch("points/points/addOrModifyRule", rule).then((data) => {
        if (data.code !== "0") {
          this.$message.error(data.msg);
          return;
        }
        this.cancelRule();
      });
    },
    cancelRule() {
      this.$router.push("/mj/pointsList");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
